import { HeaderItem, HeaderLinkWithIconAndSubtitle } from './types';

export function isMainHeaderMenuItem(
  item: HeaderItem
): item is HeaderItem & { links: HeaderLinkWithIconAndSubtitle[] } {
  return 'links' in item;
}
